module.exports = __webpack_public_path__ + "sala-guco.jpg?c95bef8af0df241bb4350947a84685e4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sala-guco.jpg
// module id = 26
// module chunks = 0